import React, { useState } from 'react';

import TextareaAutosize from 'react-textarea-autosize';

import InputTitleWrap from 'components/Inputs/InputTitleWrap';
import AppPriceInput from 'components/Inputs/AppPriceInput';
import PillSearch from 'components/Inputs/PillSearch';
import { useItemContext } from 'components/SingleItem/ItemContext';
import styles from './General.module.scss';
import { Venue } from '../../generated/graphql';

const DESCRIPTION_KEY = 'description' as const;

interface Props {
  dietaryEnums: string[];
  handleSetSamePriceOnAllApps: () => void;
  isSameOnAllApps: boolean;
  currentVenue: Venue | undefined;
  hasBrands: boolean;
}

const General: React.FC<Props> = ({
  dietaryEnums,
  handleSetSamePriceOnAllApps,
  isSameOnAllApps,
  currentVenue,
  hasBrands
}) => {
  const { item, handleChange } = useItemContext();
  const [descriptionDisplay, updateDescriptionDisplay] = useState(item?.description.trim() || '');

  if (!item || !currentVenue) {
    return null;
  }

  const { variablesByApp, dietary } = item;

  return (
    <ul className={`${styles.General}`} data-testid="general-container">
      {variablesByApp && (
        <li data-testid="general-price-by-app">
          <AppPriceInput
            handleSetSamePriceOnAllApps={handleSetSamePriceOnAllApps}
            isSameOnAllApps={isSameOnAllApps}
            currentVenue={currentVenue}
            hasBrands={hasBrands}
          />
        </li>
      )}
      <li>
        <InputTitleWrap title="Description" testId={DESCRIPTION_KEY} tabIndex={0}>
          <TextareaAutosize
            data-testid={`textarea-autosize-${DESCRIPTION_KEY}`}
            value={descriptionDisplay}
            onChange={(e) => {
              handleChange({
                key: DESCRIPTION_KEY,
                payload: e.target.value
              });
              updateDescriptionDisplay(e.target.value);
            }}
            onBlur={(e) => updateDescriptionDisplay(e.target.value.trim())}
            onFocus={() => updateDescriptionDisplay(item?.description || '')}
            placeholder="No description"
            className="amp-unmask"
          />
        </InputTitleWrap>
        <InputTitleWrap title="Nutritional Tags" testId="dietary" tabIndex={0}>
          <PillSearch
            values={dietary}
            allOptions={dietaryEnums}
            handleChange={(dietary) => {
              handleChange({
                key: 'dietary',
                payload: dietary
              });
            }}
          />
        </InputTitleWrap>
      </li>
    </ul>
  );
};

export default General;
